(function () {

  'use strict';

  // ─────────────────────────────────────────────────────────────
  // ORPHANED ADDON CLEANUP
  // ─────────────────────────────────────────────────────────────
  //
  // Addon-Produkte (z.B. "Aufpreis Paspelierung") werden als eigene
  // Cart-Line hinzugefügt und über die Property "_addon_of" mit der
  // Line-Key des Hauptprodukts verknüpft. Wird das Hauptprodukt
  // entfernt (z.B. auf der /cart Seite, wo die Seite neu lädt statt
  // ein Event zu feuern), bleibt die Addon-Zeile sonst verwaist im
  // Warenkorb zurück. Diese Funktion entfernt solche verwaisten
  // Addon-Zeilen automatisch.

  function removeOrphanedAddons(cart) {

    if (!cart || !cart.items) return;

    var existingKeys = cart.items.map(function (item) {
      return item.key;
    });

    var updates = {};
    var hasOrphans = false;

    cart.items.forEach(function (item) {

      var parentKey =
        item.properties &&
        item.properties['_addon_of'];

      if (
        parentKey &&
        existingKeys.indexOf(parentKey) === -1
      ) {
        updates[item.key] = 0;
        hasOrphans = true;
      }
    });

    if (!hasOrphans) return;

    fetch('/cart/update.js', {

      method: 'POST',

      headers: {
        'Content-Type': 'application/json'
      },

      body: JSON.stringify({
        updates: updates
      })
    })

      .then(function () {

        document.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true
          })
        );
      })

      .catch(function () {});
  }

  document.addEventListener(
    'cart:change',
    function (e) {
      removeOrphanedAddons(e.detail && e.detail.cart);
    }
  );

  fetch('/cart.js')

    .then(function (r) {
      return r.json();
    })

    .then(removeOrphanedAddons)

    .catch(function () {});

})();
